export enum CycleCountStatus {
  NEW = 'new',
  IN_PROGRESS = 'in_progress',
  RECOUNT_IN_PROGRESS = 'recount_in_progress',
  COMPLETE = 'complete',
}
